'<template>
   <div class="page_list_container">
      <div class="list_titlebox">
         <h5>会员单位</h5>
      </div>
      <div class="list_navigation max_width">
         当前位置：<router-link to="/">首页 - </router-link><a v-for="(item,i) in leftNav"   v-if="item.id == leftActive">{{item.name}}</a>
      </div>
      <div class="list_content">
         <div class="max_width">
            <div class="list_left">
               <div class="left_nav">
                  <div class="l_nav_item" v-for="(item,i) in leftNav" :class="item.id == leftActive?'active':''" v-if="item.status">
                     <router-link :to="item.path">
                        <i class="iconfont" v-if="item.icon != ''" v-html="item.icon"></i>{{item.name}} <span class="iconfont">&#xe610;</span>
                     </router-link>
                  </div>
               </div>
            </div>
            <!--右侧-->
            <template v-if="data != null">
               <router-view />
            </template>
         </div>
      </div>
   </div>
</template>


<script>
   import {
      formatDates,
      getDistanceSpecifiedTime
   } from '@/assets/js/date.js'; // 时间倒计时
   export default {
      name: 'user_layout_page',
      components: {},
      data() {
         return {
            loading: true,
            data: null, //会员信息

            leftNav:[
               {
                  name:'企业信息',
                  path:'/user/member',
                  icon:'',
                  status:true,
                  id:1,
               },
               {
                  name:'',
                  path:'/user/director',
                  icon:'',
                  status:true,
                  id:2,
               },
               {
                  name:'上传资料',
                  path:'/user/memberList',
                  icon:'',
                  status:true,
                  id:3,
               },
               {
                  name:'VIP资料',
                  path:'/user/vipList',
                  icon:'&#xe634;',
                  status:false,
                  id:4,
               },
               {
                  name:'修改密码',
                  path:'/user/changPassword',
                  icon:'',
                  status:true,
                  id:5,
               },
               {
                  name:'通知消息',
                  path:'/user/message',
                  icon:'',
                  status:true,
                  id:6,
               },
            ],
            leftActive:1,
         };
      },
      mounted() {
         this.init();
         this.reashNav();
      },
      methods: {
         init() {
            var _this = this;
            _this.$api.companyInfo({
               token: _this.$getCookie('sd_token')
            }).then(res => {
               if (res.code == 200) {
                  _this.data = res.data;
                  localStorage.setItem('userInfo', JSON.stringify(res.data));
                  if(res.data.companyType == 1){
                     _this.leftNav[1].name = "会员单位"
                  }else if(res.data.companyType == 2){
                     _this.leftNav[1].name = "理事信息"
                  }else if(res.data.companyType == 3){
                     _this.leftNav[1].name = "常务理事"
                  }
                  if(res.data.isVip == 'Y'){
                     _this.leftNav[3].status = true;
                  }
               } else {
                  _this.$message.error(res.msg);
               }
            }).catch(function(error) {
               _this.loading = false;
               _this.$message.error(error.msg);
            });
         },
         reashNav(){
            let _this = this;
            var thisPath = _this.$route.path,indexs = '';
            for(var i=0;i<_this.leftNav.length;i++){
               if(thisPath.indexOf(_this.leftNav[i].path) != -1){
                  indexs = _this.leftNav[i].id;
               }
            }
            _this.leftActive = indexs;
         },
      }
   }
</script>
<style lang="less" scoped>

</style>
